"use client";

import { itemVariants } from '@/lib/utils/util';
import { Link } from '@/navigation';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import React from 'react'

function IntroductionCard() {
    const t = useTranslations();

    return (
        <div id="introduction" className="bg-white scroll-mt-40">
        <div className="container mx-auto grid grid-cols-2 py-8 sm:py-12 md:py-16 max-lg:grid-cols-1 gap-4 sm:gap-6 md:gap-8 items-stretch px-4 sm:px-6">
          {/* Left Side - Image */}
          <div className="w-full h-full relative min-h-[250px] sm:min-h-[350px] md:min-h-[400px] lg:min-h-[600px]">
            <img
              alt={t('plsyy.companyIntroductionTitle')}
              className="absolute inset-0 w-full h-full object-cover rounded-xl sm:rounded-2xl"
              src="/image/plsyy/about/about.webp"
            />
          </div>
          {/* Right Side - Text Content */}
          <div className="box-border w-full h-full flex flex-col justify-between p-4 sm:p-6 md:p-8 min-h-auto lg:min-h-[500px]">
            <h2 className="mb-4 sm:mb-6 text-xl sm:text-2xl md:text-3xl xl:text-4xl font-bold text-gray-900 leading-tight sm:leading-relaxed">
              {t('plsyy.companyIntroductionTitle')}
            </h2>
            <p className="mb-3 sm:mb-4 text-sm sm:text-base xl:text-lg leading-relaxed text-[#545454]">
              {t('plsyy.companyIntroductionPara1')}
            </p>
            <p className="mb-6 sm:mb-8 text-sm sm:text-base xl:text-lg leading-relaxed text-[#545454]">
              {t('plsyy.companyIntroductionPara2')}
            </p>
            <Link
              href="/products"
              className="inline-flex items-center gap-2 w-fit px-4 sm:px-6 py-2 sm:py-3 border-2 border-gray-400 text-gray-800 font-medium hover:border-mainColor hover:text-mainColor transition-all duration-300 text-sm sm:text-base xl:text-lg"
            >
              {t('plsyy.readMoreProducts')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

          {/* Digital Showroom Link Section */}
          <motion.div
            variants={itemVariants}
            className="container mx-auto mb-8 sm:mb-12 md:mb-16 px-4 sm:px-6"
          >
            <div className="flex items-center justify-between gap-4 sm:gap-6 p-4 sm:p-6 bg-mainColor/5 border border-mainColor rounded-xl max-md:flex-col max-md:items-start">
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed flex-1 mb-3 sm:mb-0">
                {t('plsyy.digitalShowroomDesc')}
              </p>
              <a
                href="https://qingk.leadsmee.com/djUoeKAyEOSc/en.html?mwheel=false"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 sm:px-6 py-2 sm:py-3 bg-mainColor text-white font-semibold hover:bg-mainColor/90 transition-all duration-300 rounded-lg shadow-md hover:shadow-lg whitespace-nowrap text-sm sm:text-base w-full sm:w-auto justify-center"
              >
                {t('plsyy.digitalShowroomButton')}
                <i className="ri-external-link-line"></i>
              </a>
            </div>
          </motion.div>
      </div>
    )
}

export default IntroductionCard;